import React from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@pd/pd-ui-kit";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";

import { useRejectViolationMutation } from "~/schemas/generated/graphql";
import { Field } from "~/shared/ui/Field";

import s from "./SanctionsModal.less";

const SANCTION_OPTIONS = [
  "violation.sanction1",
  "violation.sanction2",
  "violation.sanction3",
  "violation.sanction4",
];

const SanctionsModal = ({ refetch, closeModal, id }) => {
  const { t } = useTranslation();

  const schema = yup.object().shape({
    punishment: yup.string().required(t("validation.requiredRadio")),
  });
  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const [rejectViolation] = useRejectViolationMutation({
    onCompleted: () => {
      refetch();
      closeModal();
    },
  });

  const onSubmit = ({ punishment }) => {
    rejectViolation({
      variables: {
        id,
        punishment: t(punishment),
      },
    });
  };

  return (
    <div className={s.wrapper}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          type="radio"
          name="punishment"
          control={control}
          error={errors?.punishment?.message}
          options={SANCTION_OPTIONS.map((key) => ({
            value: key,
            label: t(key),
          }))}
        />
        <div className={s.controls}>
          <Button htmlType="submit" size="large" fontSize={"14"}>
            {t("violation.apply")}
          </Button>
          <Button color={'secondary'} size="large" fontSize={'14'} onClick={closeModal}>
            {t("violation.cancel")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SanctionsModal;
